module.exports = __webpack_public_path__ + "static/media/EVS_BannerSite_ProdutoNacional.af2f1551.webp";